<template>
	<div :class="tabClass" v-show="isShown" v-if="isTab" :data-id="id && showId ? id : null">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		props: {
			name: {
				type: String,
				default: '',
			},
			id: {
				type: String,
				default: ''
			},
			showId: {
				type: Boolean,
				default: false
			},
			selected: {
				type: Boolean,
				default: false
			},
			extraClasses: {
				default: () => [ 'has-padding', 'no-padding-top' ]
			},
			show: {
				type: Boolean,
				default: true
			},
			isTab: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				isActive: this.selected,
				isShown: this.show
			};
		},
		computed: {
			tabClass() {
				let classes = [ 'tab-pane', 'fade' ];

				for (let index in this.extraClasses) {
					classes.push(this.extraClasses[index]);
				}

				if (this.isActive) {
					classes.push('in active');
				}

				return classes;
			}
		},
		watch: {
			isActive: function (isActive) {
				this.$emit('activeChange', isActive, this.id);
			}
		}
	}
</script>